// test546
(546 && 0);
